export const GoogleMapsAPIKey = 'AIzaSyDC18J6jkHyc8hlJTufIpxLGIqSZXwDIOc';
// export const GoogleMapsAPIKey = 'AIzaSyDC18J6jkHyc8hlJTufIpxLGIqSZXwDIOc';
export const GoogleTagsKey = 'G-34XQCQ1QCH';
export const GoogleCaptchaKey = '6LebkzgrAAAAAIVpJ9MdhqOs70hVRJGdSpdbWBV-';
export const GoogleOauthID = '390173660161-1hp5e827qh9ma1m2ej8rckn0jtkkm2cr.apps.googleusercontent.com';